import React from "react";

const AppStore = () => <center><h1>To go deeper, download the <a href="https://itunes.apple.com/us/app/joels-kitchen/id1151259671?mt=8">Joel's Kitchen app</a>!</h1></center>;

export default AppStore


// WEBPACK FOOTER //
// ./src/appstore.jsx